"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _noVideosFound = _interopRequireDefault(require("../../common/no-videos-found/no-videos-found"));

const NoPublishedFound = () => /*#__PURE__*/_react.default.createElement(_noVideosFound.default, {
  className: "no-published-found",
  title: "You have no published videos yet",
  description: "Publish your drafts or create a new video"
});

var _default = NoPublishedFound;
exports.default = _default;